import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { WdxToastService } from '@wdx/shared/components/wdx-toast';
import {
    ROUTE_PREFIX,
    Severity,
    SignalrEvent,
    TRANSLATION_TOAST_MESSAGE_EXPORT_BACKGROUND_JOB,
    TranslationsService,
    URL_DATA_MANAGEMENT_EXPORT,
} from '@wdx/shared/utils';
import { of } from 'rxjs';
import { catchError, filter, map, mergeMap, tap } from 'rxjs/operators';
import { newSystemSignalrEvent } from '../system-events/system-events.actions';
import * as exportsActions from './exports.actions';
import { ExportsService } from './exports.service';

@Injectable()
export class ExportsEffects {
    private actions$ = inject(Actions);
    private exportsService = inject(ExportsService);
    private toastService = inject(WdxToastService);
    private translationsService = inject(TranslationsService);

    doExport$ = createEffect(() =>
        this.actions$.pipe(
            ofType(exportsActions.doExport),
            mergeMap((action) =>
                this.exportsService
                    .doExport({
                        queryType: action.queryType,
                        payload: action.payload,
                        entityId: action.entityId,
                    })
                    .pipe(
                        map(() => {
                            return exportsActions.doExportSuccess({
                                queryType: action.queryType,
                            });
                        }),
                        catchError((error) => {
                            return of(
                                exportsActions.doExportFailure({
                                    error,
                                }),
                            );
                        }),
                    ),
            ),
        ),
    );

    doExportSuccess$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(exportsActions.doExportSuccess),
                tap(() => {
                    this.toastService.show({
                        body: [
                            this.translationsService.getTranslationByKey(
                                TRANSLATION_TOAST_MESSAGE_EXPORT_BACKGROUND_JOB,
                            ),
                        ],
                        severity: Severity.Success,
                        closeOthers: true,
                        bodyRouterLink: [
                            ...ROUTE_PREFIX,
                            ...URL_DATA_MANAGEMENT_EXPORT,
                        ],
                    });
                }),
            ),
        { dispatch: false },
    );

    listenToEvents$ = createEffect(() =>
        this.actions$.pipe(
            ofType(newSystemSignalrEvent),
            filter(
                ({ event }) =>
                    event.signalrEvent === SignalrEvent.ExportGenerated,
            ),
            map(() => exportsActions.refreshExports()),
        ),
    );
}
